enum DocRevisionEnum {
  draft = 'draft',
  published = 'published',
  approval = 'approval',
}

export default DocRevisionEnum
export type DocRevisionEnumStrings = keyof typeof DocRevisionEnum
export type DocRevisions = DocRevisionEnumStrings | DocRevisionEnum
